import { motion } from "framer-motion";
import uda from "../../accests/udawalawa/udawalawa (4).jpeg"
import uda1 from "../../accests/udawalawa/udawalawa (6).jpeg"
import uda2 from "../../accests/udawalawa/udawalawa (2).jpeg"
import uda3 from "../../accests/udawalawa/udawalawa (3).jpeg"
import uda4 from "../../accests/udawalawa/udawalawa (1).jpeg"

// Unsplash images
const safariImg =
    uda
const transitImg =
   uda1;

export default function UdawalaweDayTour() {

    const highlights = [
        {
            title: "Udawalawe National Park Safari",
            desc: "Enjoy an exciting 4×4 jeep safari through vast grasslands where wild Asian elephants roam freely, offering incredible wildlife encounters.",
            img: uda1,
        },
        {
            title: "Elephant Transit Home",
            desc: "Visit the Elephant Transit Home, a rehabilitation centre caring for orphaned elephant calves before releasing them back into the wild.",
            img: uda,
        }
    ];

    const itinerary = [
        "Pickup from your hotel",
        "Drive towards Udawalawe National Park",
        "4×4 jeep safari to spot wild elephants",
        "Visit Elephant Transit Home",
        "Lunch at a local restaurant",
        "Bird watching and scenic photo stops",
        "Return to your hotel",
    ];

    return (
        <div className="pt-28 bg-gray-50">

            {/* HERO */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                className="relative h-[60vh]"
            >
                <img
                    src={uda}
                    alt="Udawalawe National Park Safari"
                    className="w-full h-full object-cover brightness-75"
                />

                <div className="absolute inset-0 flex flex-col justify-center items-center text-center text-white px-6">
                    <motion.h1
                        initial={{ y: -40, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 1, delay: 0.3 }}
                        className="text-5xl md:text-6xl font-bold drop-shadow-lg"
                    >
                        Udawalawe Day Tour
                    </motion.h1>

                    <motion.p
                        initial={{ y: 40, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 1, delay: 0.6 }}
                        className="mt-4 max-w-2xl text-lg drop-shadow-md"
                    >
                        A memorable safari experience featuring wild elephants,
                        scenic landscapes, and a visit to the Elephant Transit Home.
                    </motion.p>
                </div>
            </motion.div>

            {/* INTRO */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="max-w-5xl mx-auto px-6 py-16 text-center">
                <h2 className="text-3xl font-bold mb-6 text-gray-800">
                    One of the Best Elephant Safaris in Sri Lanka
                </h2>
                <p className="text-gray-700 leading-relaxed">
                    Udawalawe National Park is famous for its large population of
                    wild Asian elephants and open landscapes that provide excellent
                    wildlife viewing. Combined with a visit to the Elephant Transit
                    Home, this tour offers both adventure and conservation insight.
                </p>
            </section>

            {/* HIGHLIGHTS */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="max-w-7xl mx-auto px-6 py-16">
                <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
                    Tour Highlights
                </h2>

                <div className="grid md:grid-cols-2 gap-10">
                    {highlights.map((item, index) => (
                        <motion.div
                            key={index}
                            whileHover={{ scale: 1.05 }}
                            className="bg-white rounded-3xl shadow-lg overflow-hidden"
                        >
                            <img
                                src={item.img}
                                alt={item.title}
                                className="w-full h-64 object-cover"
                            />
                            <div className="p-6">
                                <h3 className="text-2xl font-semibold text-yellow-500 mb-2">
                                    {item.title}
                                </h3>
                                <p className="text-gray-700 text-sm">{item.desc}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </section>

            {/* ITINERARY */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="bg-gray-100 py-16">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-start">

                    {/* LEFT */}
                    <div>
                        <h2 className="text-3xl font-bold mb-10 text-gray-800">
                            Detailed Itinerary
                        </h2>

                        <ul className="space-y-4 text-gray-700 list-decimal list-inside">
                            {itinerary.map((step, index) => (
                                <motion.li
                                    key={index}
                                    initial={{ x: -40, opacity: 0 }}
                                    whileInView={{ x: 0, opacity: 1 }}
                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                    className="text-lg"
                                >
                                    {step}
                                </motion.li>
                            ))}
                        </ul>
                    </div>

                    {/* RIGHT IMAGES */}
                    <div data-aos="fade-up"
                         data-aos-duration="3000" className="grid grid-cols-2 gap-4">
                        {[uda1, uda2, uda3, uda4].map((img, i) => (
                            <motion.img
                                key={i}
                                src={img}
                                alt="Udawalawe safari"
                                whileHover={{ scale: 1.05 }}
                                className="h-40 w-full object-cover rounded-2xl shadow-lg"
                            />
                        ))}
                    </div>

                </div>
            </section>

            {/* WHY CHOOSE + CTA */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="relative py-24 overflow-hidden">

                {/* BACKGROUND */}
                <div className="absolute inset-0">
                    <img
                        src={safariImg}
                        alt="Why choose Udawalawe tour"
                        className="w-full h-full object-cover scale-110 blur-md"
                    />
                    <div className="absolute inset-0 bg-black/60"></div>
                </div>

                {/* CONTENT */}
                <div data-aos="fade-up"
                     data-aos-duration="3000" className="relative max-w-6xl mx-auto px-6 text-white text-center">

                    <h2 className="text-3xl md:text-4xl font-bold mb-10">
                        Why Choose This Tour?
                    </h2>

                    <ul className="max-w-3xl mx-auto space-y-4 text-lg list-disc list-inside
                                   backdrop-blur-md bg-white/10 p-8 rounded-3xl shadow-xl">
                        <li>One of the best places in Sri Lanka to see wild elephants.</li>
                        <li>High success rate for elephant sightings.</li>
                        <li>Visit the Elephant Transit Home rehabilitation centre.</li>
                        <li>Perfect for wildlife lovers and photographers.</li>
                        <li>Guided by experienced local safari guides.</li>
                    </ul>
                    {/* CTA */}
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="mt-14"
                    >
                        <motion.a
                            whileHover={{ scale: 1.08 }}
                            whileTap={{ scale: 0.95 }}
                            href="https://wa.me/94770163670?text=Hello%20I%20would%20like%20to%20book%20the%20Udawalawe%20Day%20Tour"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center px-14 py-4
        bg-yellow-500 text-black font-semibold text-lg
        rounded-full shadow-xl hover:bg-yellow-400
        transition-all duration-300"
                        >
                            Book Udawalawe Day Tour
                        </motion.a>

                        <p className="mt-4 text-sm text-gray-200">
                            🐘 Elephant sightings • 🚙 Jeep safari • 🌿 Conservation visit
                        </p>
                    </motion.div>


                </div>
            </section>

        </div>
    );
}
